<template>
  <PrintTemplate :viewExtraFooter="false" :viewHeader="true" :viewFooter="true">
    <div v-loading="isLoading">
      <table class="table table-bordered">
        <tr>
          <td colspan="3">Job Order No.</td>
          <td colspan="9">{{ formModel.job_order_number }}</td>
        </tr>
        <tr>
          <td colspan="3">ULD ID Code</td>
          <td colspan="9">{{ masterlist.uld_id_code }}</td>
        </tr>
        <tr>
          <td colspan="3">TSO Ser No.</td>
          <td colspan="9">{{ masterlist.tso_serial_no }}</td>
        </tr>
        <tr>
          <td colspan="3">ULD Part No.</td>
          <td colspan="9">{{ masterlist.part }}</td>
        </tr>
        <tr>
          <td colspan="3">Manufacturer</td>
          <td colspan="9">{{ masterlist.manufacturer }}</td>
        </tr>
        <tr>
          <td colspan="3">ULD Age</td>
          <td colspan="9">{{ masterlist.uld_age }}</td>
        </tr>
        <tr>
          <td colspan="12" style="height: 24px"></td>
        </tr>
        <tr>
          <td colspan="3">Labor Cost Estimate</td>
          <td colspan="9">{{ formModel.labor_cost | currency }}</td>
        </tr>
        <tr>
          <td colspan="3">Parts Cost Estimate</td>
          <td colspan="9">{{ totalCost | currency }}</td>
        </tr>
        <tr>
          <td colspan="3">Total Repair Cost</td>
          <td colspan="9">
            {{ (formModel.labor_cost + totalCost) | currency }}
          </td>
        </tr>
        <tr>
          <td colspan="12" style="height: 24px; "></td>
        </tr>
        <tr>
          <td colspan="3">BER Limit</td>
          <td colspan="9">{{ formModel.ber | currency }}</td>
        </tr>
        <tr>
          <td colspan="12" style="text-align: center">LABOR</td>
        </tr>
        <tr>
          <td colspan="3" class="text-center">Rate</td>
          <td colspan="6" class="text-center">Estimated Man-Hour</td>
          <td colspan="3" class="text-center">Total</td>
        </tr>
        <tr>
          <td colspan="3" class="text-center">
            {{ formModel.rate | currency }}
          </td>
          <td colspan="6" class="text-center">
            {{ formModel._repair_time }}
          </td>
          <td colspan="3" class="text-center">
            {{ formModel._total_labor_cost | currency }}
          </td>
        </tr>
        <tr>
          <td colspan="12" style="height: 24px"></td>
        </tr>
        <tr>
          <td colspan="12" style="text-align: center">PARTS</td>
        </tr>
        <tr>
          <td colspan="3" class="text-center">Description</td>
          <td colspan="3">Part No.</td>
          <td colspan="3">Qty.</td>
          <td colspan="3">Amount</td>
        </tr>
        <!-- <template v-for="(damage, i1) in formModel.damages"> -->
        <template v-for="(part, i2) in parts">
          <tr :key="`spare_part_${i2}`">
            <td colspan="3">{{ part.description }}</td>
            <td colspan="3">{{ part.part_no }}</td>
            <td colspan="3">{{ part.quantity }}</td>
            <td colspan="3">
              {{ part.total_cost | currency }}
            </td>
          </tr>
        </template>
        <!-- </template> -->
        <tr>
          <td colspan="9">Total Parts Cost Estimate</td>
          <td colspan="3">
            {{ totalCost | currency }}
          </td>
        </tr>
      </table>

      <div class="masonry mt-2">
        <masonry :cols="3" :gutter="15">
          <div
            v-for="(file, index) in ber_images"
            :key="`img-${index}`"
            style="position: relative"
          >
            <img :src="getImageSrc(file)" alt="img" />
          </div>
        </masonry>
      </div>
    </div>
  </PrintTemplate>
</template>

<script>
import PrintTemplate from "@/components/PrintTemplate.vue";
import ULD from "@/models/ULD";
// import Masterlist from "@/models/Masterlist";
export default {
  name: "EstimateReport",
  components: { PrintTemplate },
  data: () => ({
    isLoading: true,
    formModel: new ULD(),
    masterlist: {},
    parts: [],
    ber_images: []
  }),
  computed: {
    totalCost() {
      if (this.formModel.id) {
        let totalCost = 0;
        // for (let damage of this.formModel.damages) {
        for (let part of this.parts) {
          totalCost += parseFloat(part.total_cost);
        }
        // }

        return totalCost;
      }
      return 0;
    }
  },
  methods: {
    getImageSrc(file) {
      return "data:image/jpg;base64," + file.image;
    }
  },
  mounted() {
    this.parts = [];
    if (this.$route.params && this.$route.params.id) {
      ULD.list({ id: this.$route.params.id }).then(data => {
        this.isLoading = false;

        let item = data.data[0];

        this.formModel = item;
        this.masterlist = item.masterlist;

        let repairTime = "";
        let time = this.formModel.time_rendered.split(":");
        let hh = time[0] ? parseInt(time[0]) : 0;
        let mm = time[1] ? parseInt(time[1]) : 0;
        if (hh > 0)
          repairTime = this.$options.filters.pluralize(hh, "hour", {
            includeNumber: true
          });
        if (repairTime) repairTime += " ";

        if (mm > 0)
          repairTime += this.$options.filters.pluralize(mm, "minute", {
            includeNumber: true
          });
        this.formModel._repair_time = repairTime;
        this.formModel._total_labor_cost =
          hh * this.formModel.rate + (mm / 60) * this.formModel.rate;

        //   <template v-for="(damage, i1) in formModel.damages">
        //   <template v-for="(part, i2) in damage.spare_parts">
        //     <tr :key="`spare_part_${i1}-${i2}`">
        //       <td colspan="3">{{ part.parts_used.description }}</td>
        //       <td colspan="3">{{ part.parts_used.part_no }}</td>
        //       <td colspan="3">{{ part.quantity }}</td>
        //       <td colspan="3">
        //         {{ (part.quantity * part.material_cost) | currency }}
        //       </td>
        //     </tr>
        //   </template>
        // </template>
        // for (let damage of this.formModel.damages) {
        //   for (let part of damage.spare_parts) {
        //     let _part = this.parts.find(
        //       o => o.part_no == part.parts_used.part_no
        //     );
        //     if (!_part) {
        //       _part = {
        //         description: part.parts_used.description,
        //         part_no: part.parts_used.part_no,
        //         quantity: part.quantity,
        //         final_price_usd: part.parts_used.final_price_usd,
        //         final_price_aed: part.parts_used.final_price_aed,
        //         total_cost: part.quantity * part.parts_used.final_price_usd
        //       };
        //       this.parts.push(_part);
        //     } else {
        //       _part.quantity = _part.quantity + part.quantity;
        //       _part.total_cost = _part.quantity * _part.final_price_usd;
        //     }
        //   }
        // }

        // use estimates
        let estimates = JSON.parse(this.formModel.estimates);
        for (let item of estimates) {
          this.parts.push({
            ...item,
            total_cost: (item.quantity * item.amount).toFixed(2)
          });
        }

        // estimate images
        ULD.get_uld_ber({ uldin_id: this.formModel.id }).then(resp => {
          this.ber_images = resp.data;
        });

        // for (let damage of this.formModel.damages) {
        //   for (let part of damage.spare_parts) {
        //     let _part = this.parts.find(
        //       o => o.part_no == part.parts_used.part_no
        //     );
        //     if (!_part) {
        //       _part = {
        //         description: part.parts_used.description,
        //         part_no: part.parts_used.part_no,
        //         quantity: part.quantity,
        //         final_price_usd: part.parts_used.final_price_usd,
        //         final_price_aed: part.parts_used.final_price_aed,
        //         total_cost: part.quantity * part.parts_used.final_price_usd
        //       };
        //       this.parts.push(_part);
        //     } else {
        //       _part.quantity = _part.quantity + part.quantity;
        //       _part.total_cost = _part.quantity * _part.final_price_usd;
        //     }
        //   }
        // }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.table > td {
  min-width: calc(100% / 12);
}
</style>
